(function () {
  // Runs on all pages; only affects search templates
  if (!document.documentElement.classList.contains('template-search')) return;

  // Adjust selector after you inspect the DOM
  var globoPresent =
    document.querySelector('[class*="globo"]') ||
    document.querySelector('[id*="globo"]');

  if (globoPresent) {
    document.documentElement.classList.add('nov-globo-on-search');
  } else {
    document.documentElement.classList.add('nov-globo-off-search');
  }
})();
